import React from 'react'
import { Category, CategoryList } from 'lib/types'
import { NavItem } from '../NavItem'
import { RenderLink } from '../RenderLink'

interface Props {
  category: Category
  categories: Category[]
  categoryList: CategoryList
}

export const RenderChildren = ({ category, categories, categoryList }: Props) => {
  return (
    <div>
      <ul>
        {categories.map(category => {
          return (
            <NavItem
              key={category.id}
              category={category}
              categoryList={categoryList}
            />
          )
        })}
        {category && (
          <RenderLink
            category={category}
            isViewAll
          />
        )}
      </ul>
    </div>
  )
}
